import React from 'react';
import './index.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { calculateDuration } from '../../helpers';
import moment from 'moment';

const DurationComponent = ({ item }) => {

  return (
    <div className="time-duration-block">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{item?.days_type === "Transports" ? item?.from_address?.formatted_address : item?.address}</Tooltip>}
      >
        <div className="da-btn">
          {moment(item?.days_type === "Stays" ? item?.checkInDate : item?.days_type === "Tours" ? item?.checkInTime : item?.from_date).format('HH:mm')}
        </div>
      </OverlayTrigger>
      <div className="time-duration">
        <div className="span-arrow left"></div>
        {/* {calculateDuration(item?.from_date, item?.to_date)} */}
        <div className="total-hours"></div>
        <div className="span-arrow right"></div>
      </div>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{item?.days_type === "Transports" ? item?.to_address?.formatted_address : item?.address}</Tooltip>}
      >
        <div className="da-btn">
          {moment(item?.days_type === "Stays" ? item?.checkOutDate : item?.days_type === "Tours" ? item?.checkOutTime : item?.to_date).format('HH:mm')}
        </div>
      </OverlayTrigger>
    </div>
  )
};

export default DurationComponent;